import $ from "jquery"
import Cookies from "universal-cookie"
import lodash from "lodash"
import axios from "axios"

export default class Utils {
  static regexRemoveTag = /(<([^>]+)>)/gi

  static sendAnalyticsObject(
    analyticsUrl,
    shopId,
    event,
    param = null,
    uid = 0
  ) {
    let formData = new FormData()
    let cookies = new Cookies()
    formData.append("aid", shopId)
    formData.append("uid", uid)
    if (!cookies.get("AS_TOKEN"))
      cookies.set("AS_TOKEN", Date.now(), { maxAge: 1800 })
    formData.append("sid", cookies.get("AS_TOKEN"))
    formData.append("eid", event)
    if (param) formData.append("data", JSON.stringify(param))
    navigator.sendBeacon(
      analyticsUrl + "/API/shops/" + shopId + "/events",
      formData
    )
  }

  static closeLayer(display, isMobile) {
    $("#accelasearch-bar-container-container").removeClass("show")
    if (display === "full-screen")
      $("#accelasearch-bar-container-container").removeClass(display)
    if (isMobile) $("body").removeClass(display)
    $("body").removeClass("hidden-overflow")
    $("body").removeClass("as-layer-open")
    $("body").removeClass("half-screen")
    $("body").removeClass("input")
  }

  static openLayer(display, type, isMobile, trigger = false) {
    if (display === "half-screen") {
      Utils.setPosition("accelasearch-searchbar", { right: "unset", left: 40 })
      Utils.setPosition("as-autocomplete", { top: "unset", right: "unset" })
    } else if (display === "full-screen" && !isMobile)
      Utils.setPosition("accelasearch-searchbar", { left: "50%" })
    $("#accelasearch-bar-container-container").addClass("show")
    if (display === "full-screen")
      $("#accelasearch-bar-container-container").addClass(display)
    if (!isMobile) $("body").addClass(display)
    $("body").addClass(type)
    $("body").addClass("hidden-overflow")
    $("body").addClass("as-layer-open")
    if (trigger)
      setTimeout(() => document.getElementById("as-searchbar").focus(), 10)
  }

  static isOpenedLayer() {
    return $("#accelasearch-bar-container-container").hasClass("show")
  }

  static DUMMY_CONFIG = {
    baseUrl: "",
    display: "half-screen",
    show: {
      type: "",
      id: {
        desktop: "search",
        mobile: "search-mobile",
      },
      name: {
        desktop: "search",
        mobile: "search-mobile",
      },
    },
    hover: {
      isActive: false,
      changeImage: true,
      attributes: [
        {
          key: "size",
          label: "taglia",
          type: "value",
        },
        {
          key: "color",
          label: "colore",
          type: "img",
        },
      ],
    },
    priceGroup: {
      name: "General",
      id: "0",
      quantity: "0.0000",
      currency: "EUR",
    },
    queryOptions: {
      rows: 24,
      paramsToReturn: [
        "name",
        "url",
        "short_description",
        "image",
        "pricing",
        "variants",
      ],
      suggestions: 2,
      spellcheck: 2,
    },
    filters: {},
    placeholders: {
      searchbar: "Search for a product",
      resultsFor: "Results for",
      filterBy: "Filter By",
      products: "Articoli",
      labelTiles: "Search or filter by Category",
      labelTrendingCategories: "Trending Categories",
    },
    triggers: {
      sort: true,
      wordSuggestion: true,
      icebreaker: {
        isActive: false,
        number: 4,
      },
      infiniteScrolling: {
        desktop: "infinite-scrolling",
        mobile: "infinite-scrolling",
      },
      wordsHistory: {
        desktop: {
          isActive: true,
          timeframe: "1D",
        },
        mobile: {
          isActive: true,
          timeframe: "1D",
        },
      },
      barcode: false,
      placeholder: "",
      logo: "",
      raccomandationsCategories: { desktop: [], mobile: [] },
      raccomandationsProducts: [],
      categoryTiles: { desktop: [], mobile: [] },
    },
    card: {
      title: true,
      desc: true,
      price: true,
      special_price: true,
      isinstock: true,
    },
    sorts: [
      { label: "Pertinenza", key: "score", value: "DESC" },
      { label: "Prezzo crescente", key: "sellingPrice", value: "ASC" },
      { label: "Prezzo decrescente", key: "sellingPrice", value: "DESC" },
    ],
    voiceSearch: {
      active: true,
      desktop: true,
      mobile: true,
      googleAPIKEY: "asdqweqasdcsdfbvggdfzxvas",
      language: "it-IT",
    },
    autocomplete: {
      desktop: true,
      mobile: true,
      searchAttribute: "name",
      rows: 10,
      minChars: 3,
    },
    promotions: {
      listing: {
        desktop: {
          isActive: false,
          img: "",
          url: "",
        },
        mobile: {
          isActive: false,
          img: "",
          url: "",
        },
      },
      autocomplete: {
        desktop: {
          isActive: false,
          img: "",
          url: "",
        },
        mobile: {
          isActive: false,
          img: "",
          url: "",
        },
      },
      firstScreen: {
        desktop: {
          isActive: false,
          img: "",
          url: "",
        },
        mobile: {
          isActive: false,
          img: "",
          url: "",
        },
      },
      card: {
        desktop: {
          isActive: false,
          values: [],
        },
        mobile: {
          isActive: false,
          values: [],
        },
      },
    },
    stickers: [],
    alert: {},
    noProducts: {
      mostSearched: [],
      img: "",
    },
  }

  static isLocalhost() {
    return window.location.hostname === "localhost"
  }

  static getSearchUrl(baseUrl, queryOptions, priceGroup, shopId) {
    let stringToReturn = baseUrl
    stringToReturn += "/API"
    stringToReturn += "/shops/" + shopId + "/search?"
    stringToReturn += "suggestions=" + queryOptions.suggestions
    stringToReturn += "&spellcheck=" + queryOptions.spellcheck
    stringToReturn += "&customer_group_id=" + priceGroup.id
    stringToReturn += "&currency=" + priceGroup.currency
    return stringToReturn
  }

  static getFiltersFromURL(baseUrl, queryOptions, shopId) {
    let filter = ""
    let previous = null
    if (queryOptions !== undefined && Object.keys(queryOptions).length > 0) {
      for (const [id, key] of Object.keys(queryOptions)?.entries()) {
        queryOptions[key].forEach((value, index) => {
          if (value.length > 0) {
            if (
              (id === 0 && index === 0) ||
              (!!previous && queryOptions[previous][0].length === 0)
            ) {
              filter += `filters[${key}][]=${value}`
            } else {
              filter += `&filters[${key}][]=${value}`
            }
          }
          previous = key
        })
      }
    }

    let stringToReturn = baseUrl
    stringToReturn += "/API"
    stringToReturn += "/shops/" + shopId + "/seo/lookup?" + filter
    return stringToReturn
  }

  static getAutocompleteUrl(
    baseUrl,
    autocompleteOptions,
    word,
    priceGroup,
    shopId
  ) {
    let stringToReturn = baseUrl
    stringToReturn += "/API"
    stringToReturn += "/shops/" + shopId + "/search?"
    stringToReturn += "rows=" + autocompleteOptions.rows
    stringToReturn += "&customer_group_id=" + priceGroup.id
    stringToReturn += "&currency=" + priceGroup.currency
    stringToReturn += "&originated_at=" + Date.now()
    stringToReturn += "&q=" + word
    return stringToReturn
  }

  static checkLastCategory(filters, category, isCategoryTile = false) {
    let valuesToCheck = []
    let checkToReturn = false
    if (isCategoryTile) valuesToCheck = filters.map((item) => item)
    else
      filters.forEach((element) => {
        if (element.title === "categories") {
          valuesToCheck = element.values
          return false
        }
      })
    ;(isCategoryTile ? valuesToCheck : Object.keys(valuesToCheck)).forEach(
      (element) => {
        if (
          element === category &&
          element.split("/")[element.split("/").length - 1] ===
            category.split("/")[category.split("/").length - 1]
        ) {
          checkToReturn = true
          return false
        }
      }
    )
    return checkToReturn
  }

  static getCompleteCategory(categories, valuesToCheck, level) {
    let valueToReturn = ""
    valuesToCheck = valuesToCheck.map((item) => item.replace("/", ""))
    // categories
    //   .filter((category) => category !== "")
    //   .some((item) => {
    //     let check = true;
    //     let itemToCheck = item.split("/");
    //     let flattenLevels = level.flat();
    //     flattenLevels.forEach((levelItem, levelIndex) => {
    //       let itemToUse =
    //         levelItem >= 0 ? levelItem : itemToCheck.length + levelItem;
    //       if (
    //         flattenLevels.length > 1
    //           ? itemToCheck[itemToUse] &&
    //             valuesToCheck[levelIndex] &&
    //             !valuesToCheck[levelIndex].includes(itemToCheck[itemToUse])
    //           : itemToCheck[itemToUse] &&
    //             valuesToCheck[itemToUse] &&
    //             !valuesToCheck[itemToUse].includes(itemToCheck[itemToUse])
    //       )
    //         check = false;
    //     });
    //     if (check)
    //       valueToReturn = Utils.buildCategoryLabelFromLevels(
    //         itemToCheck,
    //         level
    //       );
    //     return check;
    //   });
    return valueToReturn
  }

  static buildCategoryLabelFromLevels(categoryArray, levels) {
    let valueToReturn = ""
    let maxIndex = Utils.getLastCategoryElement(categoryArray, levels)
    for (let i = 0; i <= maxIndex; i++)
      valueToReturn += categoryArray[i] + (i === maxIndex ? "" : "/")
    return valueToReturn
  }

  static getLastCategoryElement(categoryArray, levels) {
    let flattenLevels = levels.flat()
    let maxIndex = flattenLevels.map((item) =>
      item >= 0 ? item : categoryArray.length + item
    )
    let valueToReturn = Math.min(
      Math.max(...maxIndex),
      categoryArray.length - 1
    )
    return valueToReturn
  }

  static insertWordInSearchUrl(
    baseUrl,
    word,
    activeFilters,
    sort,
    page,
    configFilters = {},
    rows
  ) {
    let urlToReturn = baseUrl
    let multiChoiceIndex = -1
    activeFilters.forEach((item, index) => {
      let isDynamicFacet = !configFilters[item.key]
      let configFiltersItem = isDynamicFacet
        ? configFilters.dynamicFacets
        : configFilters[item.key]
      // if(Object.keys(configFilters).length>0 && (configFilters[item.key].type==="checkbox-MC" || configFilters[item.key].type==="button-MC" || configFilters[item.key].type==="alph-MC")){
      if (
        Object.keys(configFilters).length > 0 &&
        ((isDynamicFacet && configFiltersItem.type.includes("-MC")) ||
          Utils.isMultiChoiceFilter(configFilters, item.key))
      ) {
        multiChoiceIndex = Utils.getFirstIndexFilterByKey(
          activeFilters,
          item.key
        )
        urlToReturn +=
          "&filters[" +
          multiChoiceIndex +
          "][][" +
          encodeURIComponent(item.key) +
          "]=" +
          encodeURIComponent(item.value)
      } else
        urlToReturn +=
          configFiltersItem.type === "slider" ||
          configFiltersItem.type === "rating"
            ? // urlToReturn+=(configFilters[item.key].type==='slider'||configFilters[item.key].type==='rating')?
              "&filters[" +
              index +
              "][0][" +
              encodeURIComponent(item.key) +
              "][from]=" +
              item.value[0] +
              "&filters[" +
              index +
              "][0][" +
              item.key +
              "][to]=" +
              item.value[1]
            : "&filters[" +
              index +
              "][][" +
              encodeURIComponent(item.key) +
              "]=" +
              encodeURIComponent(item.value)
    })
    if (sort.tiebrakers && sort.tiebrakers.length > 0)
      sort.tiebrakers.forEach((tiebraker, index) => {
        urlToReturn +=
          "&sort[" +
          (index + 1) +
          "][" +
          encodeURIComponent(tiebraker.key) +
          "]=" +
          encodeURIComponent(tiebraker.value)
      })
    else
      urlToReturn +=
        "&sort[0][" +
        encodeURIComponent(sort.key) +
        "]=" +
        encodeURIComponent(sort.value)
    urlToReturn += "&offset=" + (page - 1) * rows
    urlToReturn += "&size=" + rows
    urlToReturn += "&originated_at=" + Date.now()
    urlToReturn += "&q=" + encodeURIComponent(word)
    return urlToReturn
  }

  static async getAsyncData(webhook, products, priceGroup, timestamp = 0) {
    let asyncData = []
    let postObject = {
      currencyCode: priceGroup.currency,
      visitorType: priceGroup.id,
      ids: products.map((product) => product.data[webhook.key]),
    }
    return new Promise((resolve) => {
      Object.keys(webhook.fields).forEach(async (item, index, array) => {
        await axios.post(webhook.fields[item], postObject).then((response) => {
          asyncData = response.data
          if (index === array.length - 1) resolve()
        })
      })
    }).then(() => ({ asyncData: asyncData, timestamp: timestamp }))
  }

  static getFirstIndexFilterByKey(activeFilters, key) {
    let valueToReturn = 0
    activeFilters.some((item, index) => {
      if (item.key === key) {
        valueToReturn = index
        return true
      } else return false
    })
    return valueToReturn
  }

  static refactorUrl(products, imgPrefix, urlPrefix, cardImg, cardUrl) {
    const productsToReturn = products
      ?.filter((p) => typeof p !== "function")
      ?.map((product) => {
        let productToUse = lodash.cloneDeep(product)

        productToUse.data[cardUrl.key] =
          cardUrl.isActive && productToUse.data[cardUrl.key]
            ? productToUse.data[cardUrl.key].replace("{:url}", urlPrefix)
            : ""
        let images =
          cardImg.isActive && productToUse.data[cardImg.key]
            ? productToUse.data[cardImg.key].map((image) =>
                image.replace("{:image}", imgPrefix)
              )
            : []
        productToUse.data[cardImg.key] = images
        if (productToUse.variants && productToUse.variants.length > 0)
          productToUse.variants = Utils.refactorUrl(
            productToUse.variants,
            imgPrefix,
            urlPrefix,
            cardImg,
            cardUrl
          )
        return productToUse
      })

    return productsToReturn
  }

  static getFilterIndexByTitle(filters, title) {
    let valueToReturn = -1
    filters.some((item, index) => {
      if (item.title === title) {
        valueToReturn = index
        return true
      } else return false
    })
    return valueToReturn
  }

  static extractFilters(response) {
    let valueToReturn = []
    if (response?.stats)
      Object.keys(response.stats).forEach((item) => {
        valueToReturn.push({ title: item, values: response.stats[item] })
      })
    if (response.stats.sellingPrice.sum > 0)
      valueToReturn.push({
        title: "sellingPrice",
        valueMax: response.stats.sellingPrice.max,
        valueMin: response.stats.sellingPrice.min,
      })
    valueToReturn.sort((a, b) => (a.title === "category" ? -1 : 0))
    return valueToReturn
  }

  static extractFiltersWithoutFilter(filters, data) {
    let valueToReturn = []
    let response = data?.response
    let filterType = data?.filterType
    if (response?.stats)
      Object.keys(response.stats).forEach((item) => {
        if (item !== filterType)
          valueToReturn.push({ title: item, values: response.stats[item] })
        else
          valueToReturn.push(
            filters[Utils.checkTitleInArray(filters, filterType)]
          )
      })
    if (response?.stats?.sellingPrice?.sum > 0)
      valueToReturn.push({
        title: "sellingPrice",
        valueMax: response?.stats?.sellingPrice?.max,
        valueMin: response.stats.sellingPrice.min,
      })
    valueToReturn.sort((a, b) => (a.title === "category" ? -1 : 0))
    return valueToReturn
  }

  static isMultiChoiceFilter(filters, filterName) {
    return Object.keys(filters).some(
      (filter) => filter === filterName && filters[filter].type.includes("-MC")
    )
  }

  static extractFiltersWithoutCategories(filters, response) {
    let valueToReturn = []
    if (response?.stats)
      Object.keys(response.stats).forEach((item) => {
        // if(item!=='category')valueToReturn.push({ title:item,values:response.stats[item]})
        // else valueToReturn.push(filters[Utils.checkTitleInArray(filters,'category')])
        if (item !== "categories")
          valueToReturn.push({ title: item, values: response.stats[item] })
        else
          valueToReturn.push(
            filters[Utils.checkTitleInArray(filters, "categories")]
          )
      })
    if (response?.stats?.sellingPrice?.sum > 0)
      valueToReturn.push({
        title: "sellingPrice",
        valueMax: response?.stats.sellingPrice.max,
        valueMin: response?.stats.sellingPrice.min,
      })
    // valueToReturn.sort((a,b)=> a.title==="category"?-1:0)
    valueToReturn.sort((a, b) => (a.title === "categories" ? -1 : 0))
    return valueToReturn
  }

  static extractFiltersWithoutPrice(filters, response) {
    let valueToReturn = []
    if (response?.stats)
      Object.keys(response.stats).forEach((item) => {
        valueToReturn.push({ title: item, values: response.stats[item] })
      })
    if (response?.stats?.sellingPrice.sum > 0)
      valueToReturn.push(
        filters[Utils.checkTitleInArray(filters, "sellingPrice")]
      )
    valueToReturn.sort((a, b) => (a.title === "category" ? -1 : 0))
    return valueToReturn
  }

  static isChromeIos() {
    return window.navigator.userAgent.match("CriOS")
  }

  static extractDefaultcategories(response) {
    return response.stats.category ? response.stats.category : []
  }

  static createArrayOfIntegerFromOneToIndex(index) {
    return Array(index)
      .fill()
      .map((x, i) => i + 1)
  }

  static stepPage(page) {
    return parseInt((page - 1) / 4) * 4 + 1
  }

  static lastStepPage(page, pages = 0) {
    return page < pages - 3 ? parseInt((page - 1) / 4) * 4 + 1 : pages - 3
  }

  static refactorCategories(categories, level) {
    let objToReturn = []
    categories.forEach((item) => {
      objToReturn = Utils.addRefactoredCategory(objToReturn, item, level)
    })
    return objToReturn
  }

  static isSelected(array, valueToCheck) {
    let indexToCheck = -1
    let valueToCheckWithoutAsterisk = valueToCheck.value
      .replace("/*", "")
      .replace("*", "")
    array.forEach((item, index) => {
      if (item.key !== "sellingPrice") {
        const splittedValue = item.value
          ?.replace("/*", "")
          .replace("*", "")
          ?.split("/")
        let inPath = splittedValue.findIndex(
          (w) => w === valueToCheck.value.replace("/*", "").replace("*", "")
        )
        let notLeaf =
          valueToCheck.level && valueToCheck.level !== splittedValue.length - 1
        if (
          (splittedValue.at(-1) ===
            valueToCheck.value.replace("/*", "").replace("*", "") ||
            (inPath && !!notLeaf)) &&
          item.key === valueToCheck.key
        )
          indexToCheck = index
      }
    })
    if (
      indexToCheck === -1 &&
      valueToCheckWithoutAsterisk !== valueToCheck.value
    )
      array.forEach((item, index) => {
        if (
          item.value === valueToCheckWithoutAsterisk &&
          item.key === valueToCheck.key
        )
          indexToCheck = index
      })
    return indexToCheck !== -1
  }

  static refactorMasterCategories(categories) {
    let objToReturn = []
    categories.forEach((item) => {
      objToReturn = Utils.refactoredMasterCategories(objToReturn, item)
    })
    return objToReturn
  }

  static checkValueInArray(array, value) {
    let indexToCheck = -1
    array.forEach((item, index) => {
      if (item.value === value.value) indexToCheck = index
    })
    return indexToCheck
  }

  static checkKeyInArray(array, value) {
    let indexToCheck = -1
    array.forEach((item, index) => {
      if (item.key === value.key) indexToCheck = index
    })
    return indexToCheck
  }

  static checkTitleInArray(array, value) {
    let indexToCheck = -1
    array.forEach((item, index) => {
      if (item.title === value) indexToCheck = index
    })
    return indexToCheck
  }

  static checkValueAndKeyInArray(array, value, filters) {
    let indexToCheck = -1
    array.forEach((item, index) => {
      if (
        item.key === value.key &&
        (item.value === value.value ||
          filters[item.key]?.type === "rating" ||
          filters[item.key]?.type === "slider")
      )
        indexToCheck = index
    })
    return indexToCheck
  }

  static checkDisabled(category, wholeCategory, levels, categories) {
    category = category.replace("/" + wholeCategory, "")
    if (category[category.length - 1] === "/")
      category = category.substring(0, category.length - 1)
    categories = categories ? categories : []
    // if(!filters) filters=[{title:'category',values:[]}];
    // let categories = filters.filter(item=>item.title==='category')[0].values;
    let categoryToUse = Utils.getCompleteCategory(
      categories,
      category.split("/"),
      levels
    )
    let valueToReturn =
      categoryToUse === "" ||
      categories.filter((item) => {
        return item.includes(categoryToUse)
      }).length === 0
    return valueToReturn
  }

  static refactoredMasterCategories(objToReturn, category) {
    let splittedCategory = category.split("/")
    let startingIndex = 0
    let value = { value: splittedCategory[startingIndex] }
    if (Utils.checkValueInArray(objToReturn, value) === -1)
      objToReturn.push(value)
    return objToReturn
  }

  static addRefactoredCategory(objToReturn, category, level) {
    const originalCategory = category[0]
    if (!!category[0].match(/[0-9]\/[0-9]/)) {
      const indexToReplace = category[0].match(/[0-9]\/[0-9]/).index + 1
      const firstPart = category[0].slice(0, indexToReplace)
      const secondPart = category[0].slice(
        indexToReplace + 1,
        category[0].length
      )
      category[0] = firstPart + "-replaced-" + secondPart
    }
    let splittedCategory = category[0].split("/")
    //splittedCategory = splittedCategory.splice(0, 1);

    let splittedCategoryToUse = [...splittedCategory]
    splittedCategoryToUse.forEach((item, index) => {
      splittedCategory[index] = Utils.refactorCategoryLabelByLevel(
        category[0],
        level,
        index
      )
    })
    if (!!originalCategory.match(/[0-9]\/[0-9]/)) {
      splittedCategory = splittedCategory.map((cat) =>
        cat.replace("-replaced-", "/")
      )
    }
    let startingIndex = 0
    let auxObj = objToReturn
    while (startingIndex < splittedCategory.length) {
      if (!auxObj[splittedCategory[startingIndex]]) {
        auxObj[splittedCategory[startingIndex]] = {}
      }
      if (startingIndex === splittedCategory.length - 1) {
        auxObj[splittedCategory[startingIndex]].count = category[1]
      }
      auxObj = auxObj[splittedCategory[startingIndex]]
      startingIndex++
    }
    return objToReturn
  }

  static removeActiveFilter(inputArray, filter, filters) {
    let objToReturn = inputArray
    let indexToSplice = Utils.checkValueAndKeyInArray(
      inputArray,
      filter,
      filters
    )
    objToReturn.splice(indexToSplice, 1)
    return objToReturn
  }

  static returnLastCategory(category) {
    let removedWildcard = ""
    if (category.includes("/*")) {
      removedWildcard = category.split("/*")[0].split("/")
    } else {
      removedWildcard = category.split("*")[0].split("/")
    }
    return removedWildcard[removedWildcard.length - 1]
  }

  static returnIntegerArray(array) {
    return array === "" ? [0, 0] : array.map((item) => parseInt(item))
  }

  static addSliderValue(response, sliderValue) {
    // return Utils.checkLabelInFilters(response.stats,'sellingPrice')===-1?[response.stats.sellingPrice.min,response.stats.sellingPrice.max]:sliderValue;
    return [response.stats.sellingPrice.min, response.stats.sellingPrice.max]
  }

  static checkLabelInFilters(filters, label) {
    let indexToReturn = -1
    // Utils.refactorActiveFilters(filters).forEach((item,index)=> {
    Object.keys(filters).forEach((item, index) => {
      if (item === label) indexToReturn = index
      // if(Object.keys(item[0])[0]===label) indexToReturn=index;
    })
    return indexToReturn
  }

  static refactorActiveFilters(filters) {
    let objToReturn = []
    Object.keys(filters).forEach((key) => {
      objToReturn.push(filters[key])
    })
    return objToReturn
  }

  static removeSubFilters(activeFilters, value) {
    let valueAsSplittedArray = value.split("/")
    valueAsSplittedArray.pop()
    let valueToCheck = valueAsSplittedArray.join("/")
    return activeFilters.filter(
      (item) =>
        // !(item.key==='category' && item.value.includes(valueToCheck))
        !(item.key === "categories" && item.value.includes(valueToCheck))
    )
  }

  static removeMiddleFilters(activeFilters, value) {
    let valueAsSplittedArray = value.split("/")
    valueAsSplittedArray[valueAsSplittedArray.length - 1] = "*"
    let valueToCheck = valueAsSplittedArray.join("/")
    return activeFilters.filter(
      (item) =>
        // !(item.key==='category' && item.value.includes(valueToCheck))
        !(item.key === "categories" && item.value.includes(valueToCheck))
    )
  }

  static isMiddleCategory(value) {
    return (
      value.split("/")[value.split("/").length - 1] === "*" &&
      value.split("/").length === 2
    )
  }

  static getSortFromLabel(sorts, label) {
    let valueToReturn = sorts[0]
    sorts.some((item) => {
      if (item.label === label) {
        valueToReturn = item
        return true
      }
      return false
    })
    return valueToReturn
  }

  static getSortFromKey(sorts, key) {
    let valueToReturn = sorts[0]
    sorts.some((item) => {
      if (item?.key === key) {
        valueToReturn = item
        return true
      }
      return false
    })
    return valueToReturn
  }

  static getSortFromKeyValue(sorts, key, value) {
    let valueToReturn = sorts[0]
    sorts.some((item) => {
      console.log("item: ", item)
      const itemValue = typeof item?.value === 'object' ? item?.value?.value?.toLowerCase() : item?.value?.toLowerCase();
      if (item?.key === key && value?.toLowerCase() === itemValue) {
        valueToReturn = item
        return true
      }
      return false
    })
    return valueToReturn
  }

  static refactorCategoryLabelByLevel(label, level, index = 0) {
    let labelArray = label.split("/")

    if (!!label.match(/[0-9]\/[0-9]/)) {
      //TODO: do something for this case
    }
    let labelToReturn = ""
    if (level === -1) {
      labelToReturn += labelArray[labelArray.length + level]
    } else {
      labelToReturn += labelArray[index]
    }
    // levels[index].forEach((item, index) => {
    //   labelToReturn += labelArray[item >= 0 ? item : labelArray.length + item]
    //     ? labelArray[item >= 0 ? item : labelArray.length + item] +
    //       (index < levels[index].length - 1 ? "/" : "")
    //     : "";
    // });
    // if (
    //   labelArray.length >= levels.length &&
    //   index === levels.length - 1 &&
    //   index > 0
    // ) {
    //   labelToReturn += "*";
    // }
    return labelToReturn
  }

  static matchCategories(array, wordToMatch) {
    let objToReturn = []
    array.forEach((category) => {
      let categorySplitted = category.split("/")
      categorySplitted.some((item) => {
        if (item.toLowerCase().includes(wordToMatch.toLowerCase())) {
          if (
            !objToReturn.some(
              (subItem) => subItem.category.toLowerCase() === item.toLowerCase()
            )
          )
            objToReturn.push({
              fullCategory: category,
              category: item,
            })
          return true
        } else return false
      })
    })
    return objToReturn
  }

  static checkPromotionConditions(conditions, searchWord, filters) {
    let valueToReturn = true
    let arrayConditions = Object.keys(conditions)
    arrayConditions.forEach((item) => {
      if (item === "searchWord")
        valueToReturn = conditions[item].some((subItem) =>
          searchWord.toLowerCase().includes(subItem.toLowerCase())
        )
      else {
        let filteredFilters = filters.filter((subItem) => subItem.key === item)
        if (filteredFilters.length === 0) {
          valueToReturn = false
          return false
        } else
          valueToReturn &= conditions[item].some((subItem) =>
            filteredFilters.some((filter) =>
              filter.value.toLowerCase().includes(subItem.toLowerCase())
            )
          )
      }
    })
    return valueToReturn
  }

  static setLayerPosition(top, left, position = "left") {
    if (position !== "left")
      $("#accelasearch-bar-container").css("left", "unset")
    $("#accelasearch-bar-container").css("top", top)
    $("#accelasearch-bar-container").css(position, left)
  }

  static setAutocompletePosition(top, left, position = "left") {
    if (position !== "left")
      $("#accelasearch-bar-container #as-autocomplete").css("left", "unset")
    $("#accelasearch-bar-container #as-autocomplete").css("top", top)
    $("#accelasearch-bar-container #as-autocomplete").css(position, left)
  }

  static setSearchbarPosition(top, left, position = "left") {
    if (position !== "left") {
      $("#accelasearch-searchbar").css("left", "unset")
      $("#accelasearch-searchbar").css(position, left)
    } else $("#accelasearch-searchbar").css(position, left + 30)
  }

  static riSetSearchbarPosition(isMobile) {
    if (isMobile) $("#accelasearch-searchbar").css("left", 40)
    else {
      $("#accelasearch-searchbar").css("left", 20)
      Utils.setLayerPosition(0, 0)
    }
  }

  static setPosition(id, positions) {
    let objectToMove = $("#" + id)
    Object.keys(positions).forEach((item) => {
      objectToMove.css(item, positions[item])
    })
  }

  static isNotZeroOrNull(value) {
    return value != null && parseInt(value) !== 0
  }

  static getSelectedProductFromConf(
    children,
    selectedProduct,
    configurableAttribute,
    configurableAttributes,
    conf,
    index
  ) {
    let productToReturn = { ...selectedProduct }
    productToReturn[configurableAttribute] = conf
    if (index === 1)
      children.some((child) => {
        if (
          configurableAttributes?.every(
            (att) => child.data[att] === productToReturn[att]
          )
        ) {
          productToReturn = { ...child.data }
          return true
        }
        return false
      })
    else
      children.some((child) => {
        if (child.data[configurableAttribute] === conf) {
          productToReturn = { ...child.data }
          return true
        }
        return false
      })
    return productToReturn
  }

  static checkImpossibleConfiguration(
    index,
    child,
    selectedProduct,
    configurableAttributes,
    children
  ) {
    if (
      index === 1 && !!configurableAttributes &&
      !children.some(
        (item) =>
          item.data[configurableAttributes?.[0]] ===
            selectedProduct[configurableAttributes?.[0]] &&
          item.data[configurableAttributes?.[1]] === child
      )
    )
      return true
    return false
  }

  static alphabeticalRefactor(data) {
    return Object.values(
      data.reduce((r, e) => {
        let group = e[0]
        if (!r[group]) r[group] = { group, children: [e] }
        else r[group].children.push(e)
        return r
      }, {})
    )
  }

  static setNumberFormat(number, decimals, dec_point, thousands_sep) {
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'

    number = (number + "").replace(/[^0-9+\-Ee.]/g, "")
    let n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "" : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      s = "",
      toFixedFix = function (n, prec) {
        let k = Math.pow(10, prec)
        return "" + (Math.round(n * k) / k).toFixed(prec)
      }

    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".")
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || ""
      s[1] += new Array(prec - s[1].length + 1).join("0")
    }
    return s.join(dec)
  }
}
